module.exports = __webpack_public_path__ + "img/play.555c59b5.png";